/* SawaKart cart sidebar = staging's CartDrawer on Shopify's cart (theme only).

   - A native <dialog> (showModal: top layer, inert page, Esc), added to <body> on first use. Its
     content is sections/sk-cart-drawer.liquid, fetched with the Section Rendering API or returned
     by /cart/change.js in its "sections" field.
   - Opens from the header cart icon, from SK.cartDrawer.open() (sk-core.js home cards) and after
     Empire's own add-to-cart (listing cards, quick shop, product page): Empire adds the product and
     inserts its flyout, then fires cartcount:update. The flyout is kept invisible (sk-cart.css) and,
     once its opening has finished (which is when Empire traps focus in it), Empire is asked to close
     it with closeFlyouts, so Empire removes the flyout and its focus trap itself.
   - Quantity: the number changes at once; the clicks of the last 350ms (on any line) are merged into one
     /cart/update.js call, the buttons stay usable while it runs, and only the final answer is drawn
     (SK-56: before, every click was a 650ms round trip with the buttons disabled). Remove goes at once.
     Clear goes through /cart/clear.js. Checkout waits for a pending change. cartcount:update keeps
     Empire's header badge in step. If this file does not load, Empire's flyout simply stays. */
(function () {
  'use strict';
  window.SK = window.SK || {};
  if (window.SK.cartDrawer) return;

  var SECTION = 'sk-cart-drawer';
  var html = document.documentElement;
  var dialog = null;
  var content = null;
  /* SK-69: what the cart logic works on: the sidebar <dialog>, or on /cart the page's cart
     (sections/sk-cart-page.liquid, redrawn from its own section id) */
  var root = null;
  var section = SECTION;
  var pageMode = false;
  var trigger = null;
  var busy = false;
  var loaded = false;
  var lastAtc = null;
  var requestId = 0;
  var pending = {};          /* line key -> wanted quantity, not sent yet */
  var inflight = null;       /* the running update */
  var flushTimer = 0;
  var checkoutWanted = false;
  var MAX_QTY = 999;
  var DEBOUNCE = 350;

  var CLOSE_ICON = '<svg class="sk-icon sk-cart__close-ico" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';

  function routes() {
    var t = (window.Theme && window.Theme.routes) || {};
    var s = (window.skTheme && window.skTheme.routes) || {};
    return {
      cart: t.cart_url || s.cart_url || '/cart',
      change: t.cart_change_url || s.cart_change_url || '/cart/change',
      update: t.cart_update_url || s.cart_update_url || '/cart/update',
      clear: t.cart_clear_url || '/cart/clear'
    };
  }

  function onCartPage() { return document.body && document.body.classList.contains('template-cart'); }

  function reduced() {
    if (window.SK && typeof window.SK.reducedMotion === 'function') return !!window.SK.reducedMotion();
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function isModified(e) {
    return e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
  }

  /* ---------- the dialog ---------- */

  function ensure() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'sk-cart';
    dialog.setAttribute('aria-labelledby', 'sk-cart-title');
    dialog.innerHTML = '<div class="sk-cart__content" data-sk-cart-content>' + shell() + '</div>';
    document.body.appendChild(dialog);
    content = dialog.querySelector('[data-sk-cart-content]');
    root = dialog;

    dialog.addEventListener('click', onClick);
    dialog.addEventListener('submit', onSubmit);
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dialog.addEventListener('close', onClosed);
  }

  /* First open, before the cart arrives: staging's header and spinner. */
  function shell() {
    return '<div class="sk-cart__inner">' +
      '<div class="sk-cart__head"><h2 class="sk-cart__title" id="sk-cart-title">Cart</h2>' +
      '<button type="button" class="sk-cart__close" aria-label="Close cart" data-sk-cart-close>' + CLOSE_ICON + '</button></div>' +
      '<div class="sk-cart__loading"><span class="sk-cart__spinner" role="status" aria-label="Loading cart"></span></div>' +
      '</div>';
  }

  function open(options) {
    options = options || {};
    /* on the cart page the cart is already on screen: bring it up to date instead */
    if (pageMode) { if (options.html) render(options.html); else refresh(); return; }
    ensure();
    trigger = options.trigger || document.activeElement;
    if (!dialog.open) {
      dialog.classList.remove('is-closing');
      dialog.showModal();
      html.classList.add('sk-scroll-lock');
    } else {
      dialog.classList.remove('is-closing');
    }
    if (options.html) render(options.html);
    else refresh();
  }

  function close() {
    if (!dialog || !dialog.open || dialog.classList.contains('is-closing')) return;
    if (reduced()) { dialog.close(); return; }
    dialog.classList.add('is-closing');
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      dialog.removeEventListener('transitionend', onEnd);
      if (dialog.classList.contains('is-closing')) dialog.close();
    };
    var onEnd = function (e) { if (e.target === dialog) finish(); };
    dialog.addEventListener('transitionend', onEnd);
    setTimeout(finish, 400);
  }

  function onClosed() {
    dialog.classList.remove('is-closing');
    html.classList.remove('sk-scroll-lock');
    var back = trigger;
    trigger = null;
    if (back && back.isConnected && typeof back.focus === 'function') {
      try { back.focus({ preventScroll: true }); } catch (e) { /* not focusable */ }
    }
  }

  /* ---------- content ---------- */

  function render(markup) {
    var doc = new DOMParser().parseFromString(markup, 'text/html');
    var inner = doc.querySelector('[data-sk-cart-inner]');
    if (!inner || !content) return false;
    var scroller = content.querySelector('.sk-cart__body');
    var top = scroller ? scroller.scrollTop : 0;
    /* keep the keyboard on the same control (its aria-label is unique per line) */
    var active = document.activeElement;
    var hadFocus = !!(active && content.contains(active));
    var label = hadFocus ? active.getAttribute('aria-label') : null;
    var activeLine = hadFocus ? active.closest('[data-sk-cart-line]') : null;
    var nextLine = activeLine && activeLine.nextElementSibling ? activeLine.nextElementSibling.getAttribute('data-sk-cart-line') : null;
    content.replaceChildren(document.importNode(inner, true));
    loaded = true;
    var body = content.querySelector('.sk-cart__body');
    if (body && !pageMode) body.scrollTop = top;
    var refocus = pageMode ? hadFocus && !content.contains(document.activeElement) : (dialog.open && !dialog.contains(document.activeElement));
    if (refocus) {
      var back = null;
      if (label) back = content.querySelector('[aria-label="' + label.replace(/"/g, '\\"') + '"]');
      if (!back && nextLine) back = content.querySelector('[data-sk-cart-line="' + nextLine + '"] .sk-cart__step:not(:disabled)');
      if (!back) back = content.querySelector(pageMode ? '.sk-cart__step:not(:disabled), .sk-cart__empty-btn' : '[data-sk-cart-close]');
      if (back) back.focus({ preventScroll: true });
    }
    return true;
  }

  function refresh() {
    var id = ++requestId;
    if (loaded) setBusy(true);
    return fetch(routes().cart + '?section_id=' + encodeURIComponent(section), { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (markup) { if (id === requestId) render(markup); })
      .catch(function () {
        if (id === requestId && !loaded) location.assign(routes().cart);
      })
      .then(function () { if (id === requestId) setBusy(false); });
  }

  function setBusy(on) {
    busy = on;
    if (!root) return;
    root.classList.toggle('is-busy', on);
    root.querySelectorAll('[data-sk-cart-qty], [data-sk-cart-clear]').forEach(function (btn) {
      if (on) {
        if (!btn.disabled) { btn.disabled = true; btn.setAttribute('data-sk-was-enabled', ''); }
      } else if (btn.hasAttribute('data-sk-was-enabled')) {
        btn.disabled = false;
        btn.removeAttribute('data-sk-was-enabled');
      }
    });
  }

  function showError(message) {
    var box = content && content.querySelector('[data-sk-cart-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
  }

  function cartUpdated(cart) {
    if (cart && typeof cart.item_count === 'number') {
      window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
    }
  }

  /* ---------- quantity: at once on screen, merged requests ---------- */

  function hasPending() { for (var k in pending) if (Object.prototype.hasOwnProperty.call(pending, k)) return true; return false; }

  /* The line as the visitor wants it, before the server answers. */
  function showLine(line, qty) {
    var num = line.querySelector('.sk-cart__num');
    var steps = line.querySelectorAll('.sk-cart__step');
    if (num) num.textContent = qty;
    if (steps[0]) { steps[0].setAttribute('data-sk-cart-qty', qty - 1); steps[0].disabled = qty <= 1; }
    if (steps[1]) { steps[1].setAttribute('data-sk-cart-qty', qty + 1); steps[1].disabled = qty >= MAX_QTY; }
    line.classList.add('is-pending');
    if (qty === 0) {
      line.classList.add('is-removing');
      line.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
    }
    root.classList.add('is-busy');
    var box = content.querySelector('[data-sk-cart-error]');
    if (box) box.hidden = true;
  }

  function step(line, qty) {
    if (busy) return;
    qty = Math.max(0, Math.min(MAX_QTY, qty));
    var key = line.getAttribute('data-sk-cart-line');
    showLine(line, qty);
    pending[key] = qty;
    clearTimeout(flushTimer);
    if (qty === 0) flush();
    else flushTimer = setTimeout(flush, DEBOUNCE);
  }

  function flush() {
    clearTimeout(flushTimer);
    flushTimer = 0;
    if (inflight) return;                 /* sent when the running one answers */
    if (!hasPending()) { settle(); return; }
    var updates = pending;
    pending = {};
    var id = ++requestId;
    inflight = fetch(routes().update + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: [section], sections_url: routes().cart })
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok || data.status) {
            var err = new Error('cart/update');
            err.skDescription = typeof data.description === 'string' ? data.description : '';
            throw err;
          }
          return data;
        });
      })
      .then(function (cart) {
        inflight = null;
        cartUpdated(cart);
        if (hasPending()) return flush();   /* newer clicks: send them, keep what is on screen */
        if (id !== requestId) return;
        var markup = cart.sections && cart.sections[section];
        if (!(markup && render(markup))) return refresh();
      })
      .catch(function (err) {
        inflight = null;
        pending = {};
        if (id !== requestId) return;
        return refresh().then(function () { showError((err && err.skDescription) || 'Failed to update'); });
      })
      .then(settle);
  }

  /* Nothing running and nothing waiting: the sidebar shows the real cart. */
  function settle() {
    if (inflight || hasPending()) return;
    root.classList.remove('is-busy');
    if (checkoutWanted) {
      checkoutWanted = false;
      var form = content.querySelector('[data-sk-cart-checkout]');
      if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
    }
  }

  function clearCart() {
    if (busy || inflight || hasPending()) return;
    var btn = content.querySelector('[data-sk-cart-clear]');
    if (btn) btn.textContent = 'Clearing...';
    setBusy(true);
    fetch(routes().clear + '.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) { cartUpdated(cart); return refresh(); })
      .catch(function () { refresh(); });
  }

  /* ---------- events inside the sidebar ---------- */

  function onClick(e) {
    /* A click on the backdrop lands on the dialog itself, outside its box. */
    if (dialog && e.target === dialog) {
      var r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) { close(); return; }
    }
    var closer = e.target.closest('[data-sk-cart-close]');
    if (closer) { close(); return; }
    var qty = e.target.closest('[data-sk-cart-qty]');
    if (qty) {
      var line = qty.closest('[data-sk-cart-line]');
      if (line && !qty.disabled) step(line, parseInt(qty.getAttribute('data-sk-cart-qty'), 10) || 0);
      return;
    }
    if (e.target.closest('[data-sk-cart-clear]')) clearCart();
  }

  function onSubmit(e) {
    var form = e.target.closest('[data-sk-cart-checkout]');
    if (!form) return;
    var btn = form.querySelector('[type="submit"]');
    if (!btn) return;
    /* a quantity still on its way: send it first, then go */
    if (inflight || hasPending() || flushTimer) {
      e.preventDefault();
      checkoutWanted = true;
      btn.setAttribute('data-sk-label', btn.textContent);
      btn.textContent = btn.getAttribute('data-busy-text') || btn.textContent;
      flush();
      return;
    }
    btn.setAttribute('data-sk-label', btn.textContent);
    btn.textContent = btn.getAttribute('data-busy-text') || btn.textContent;
    setTimeout(function () { btn.disabled = true; }, 0);
  }

  /* Back from checkout (bfcache): the button is usable again. */
  window.addEventListener('pageshow', function () {
    if (!root) return;
    root.querySelectorAll('[data-sk-cart-checkout] [type="submit"][data-sk-label]').forEach(function (btn) {
      btn.textContent = btn.getAttribute('data-sk-label');
      btn.removeAttribute('data-sk-label');
      btn.disabled = false;
    });
  });

  /* ---------- openers ---------- */

  /* Header cart icon (keeps its /cart link for new tabs, no JS and the cart page). */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a.site-header-cart--button');
    if (!link || isModified(e) || onCartPage()) return;
    e.preventDefault();
    open({ trigger: link });
  });

  /* Remember the button that started an Empire add, to return focus to it. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.productitem__addtocart_btn, [data-quick-buy], [data-product-atc]');
    if (btn) lastAtc = btn;
  }, true);

  /* Empire's add-to-cart: take over from its flyout. Its hidden template ([data-templates]) is
     cloned for every flyout, so it is never touched; the flyouts already taken over are tracked here
     rather than by an attribute a clone could carry. */
  var handled = new WeakSet();
  window.addEventListener('cartcount:update', function () {
    if (onCartPage()) return;
    var flyouts = Array.prototype.filter.call(
      document.querySelectorAll('.atc-banner--container:not([data-sk-atc-banner])'),
      function (el) { return !el.closest('[data-templates]') && !handled.has(el); }
    );
    if (!flyouts.length) return;
    flyouts.forEach(handOver);
    var back = lastAtc && lastAtc.isConnected ? lastAtc : null;
    lastAtc = null;
    open({ trigger: back });
  });

  function handOver(flyOut) {
    handled.add(flyOut);
    flyOut.setAttribute('data-sk-handed', '');
    var released = false;
    var observer = null;
    var timer = 0;
    var release = function () {
      if (released) return;
      released = true;
      if (observer) observer.disconnect();
      clearTimeout(timer);
      /* After Empire's own reactions to the finished opening (its focus trap) have run. */
      setTimeout(function () { document.dispatchEvent(new Event('closeFlyouts')); }, 0);
    };
    var settled = function () {
      return flyOut.getAttribute('data-animation-state') === 'open' && !flyOut.hasAttribute('data-animation');
    };
    if ('MutationObserver' in window) {
      observer = new MutationObserver(function () { if (settled()) release(); });
      observer.observe(flyOut, { attributes: true, attributeFilter: ['data-animation', 'data-animation-state'] });
    }
    timer = setTimeout(release, 1500);
  }

  html.classList.add('sk-cart-on');

  /* SK-69: the cart page. The script is deferred, so the page's cart is already parsed. */
  (function initPage() {
    var page = document.querySelector('[data-sk-cart-page]');
    var pageRoot = page && page.querySelector('[data-sk-cart-root]');
    if (!pageRoot) return;
    pageMode = true;
    root = pageRoot;
    content = pageRoot.querySelector('[data-sk-cart-content]');
    section = page.getAttribute('data-section-id') || section;
    loaded = true;
    pageRoot.addEventListener('click', onClick);
    pageRoot.addEventListener('submit', onSubmit);
  })();

  window.SK.cartDrawer = {
    open: open,
    close: close,
    refresh: refresh
  };
})();
